import styled from 'styled-components';
import colors from '@designSystem/colors';
import { Link } from 'react-router-dom';

export const StyledBackButton = styled(Link)`
  display: flex;
  align-items: center;
  min-height: 40px;
  color: ${colors.green};
  font-family: 'futura-pt', sans-serif;
  line-height: 24px;
  font-weight: 450;
  font-size: 16px;
  border-radius: 8px;
  border: 0;
  background-color: ${colors.lighterGrey};
  cursor: pointer;

  & svg {
    width: 15px;
    height: 15px;
    margin-right: 10px;
  }
`;
